import { create } from "zustand";

type AgeVerificationValue = boolean | null;

interface IAgeVerificationState {
  ageVerified: AgeVerificationValue;
  setAgeVerified: (ageVerified: AgeVerificationValue) => void;
}

export const useAgeVerificationStore = create<IAgeVerificationState>(
  (set) => ({
    ageVerified: null,
    setAgeVerified: (ageVerified) => set({ ageVerified })
  }),
);
